const TIER = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};

const CATEGORY = {
  NEUTRAL: 'NEUTRAL',
  DANGER: 'DANGER',
  DARK: 'DARK',
};

const SIZE = {
  S: 'S',
  M: 'M',
};

export {
  CATEGORY,
  SIZE,
  TIER
};



// WEBPACK FOOTER //
// ./src/components/Buttons/constants.js